export const InDayTripPlanActions = {
  SET_VALUE: '@@InDayTripPlan/SET_VALUE',
};
